module.exports = __webpack_public_path__ + "img/icon-loader-voiter1.0855fa6d.svg";